import React from 'react';
import PropTypes from 'prop-types';
import {Table} from 'semantic-ui-react';
import css from './NewUserCredentialsRow.scss';
import StyledButton from "../common/StyledButton";
import Icon from "../SF/MaterialIcon";

/**
 * Represents the row in the small table that displays the access key and secret access key in the modal after a new
 * IAM user is created.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} The user credentials table
 */
const NewUserCredentialsRow = (props) => {

    /**
     * By default, the secret access key will be hidden with a visibility (eye) button. The text is hidden with black
     * circle characters, similar to how password text is hidden. Click the button to show the secret access key with a
     * visibility off (crossed out eye) button. Click visibility off icon to rehide secret access key.
     *
     * @returns {JSX.Element} The secret access key hidden with visibility (eye) icon button. Or secret access key
     *              shown with visibility off (crossed out eye) icon button.
     */
    const getSecretAccessKey = () => {
        if (props.showSecretKey) {
            return <div className={css['secret-access']}>
                <input className={css['secret-access-key']}
                       type={'text'}
                       readOnly={true}
                       value={props.secretAccessKey}
                       data-testid={"secret-showing"}/>
                <StyledButton asLink
                              className={css['visibility-button']}
                              aria-disabled={false}
                              onClick={props.onClickShowSecretKey}
                              id={"hide-secret-key"}
                              arial-label={"hide-secret-key"}
                              title={"Hide"}>
                    <Icon icon='visibility_off'
                          className={css['visibility-icon']}
                          aria-hidden='true'/>
                </StyledButton>
            </div>
        } else {
            return <div className={css['secret-access']}>
                <input className={css['secret-access-key']}
                       type={'password'}
                       readOnly={true}
                       value={props.secretAccessKey}
                       data-testid={"secret-hidden"}/>
                <StyledButton asLink
                              className={css['visibility-button']}
                              aria-disabled={false}
                              onClick={props.onClickShowSecretKey}
                              id={"show-secret-key"}
                              arial-label={"show-secret-key"}
                              title={"Show"}>
                    <Icon icon='visibility'
                          className={css['visibility-icon']}
                          aria-hidden='true'/>
                </StyledButton>
            </div>
        }
    }

    return (
        <Table.Row className={css['credentials-row']}>
            <Table.Cell className={css['access-key']}>
                <input className={css['access-key-textbox']}
                       type={'text'}
                       readOnly={true}
                       value={props.accessKey}/>
            </Table.Cell>
            <Table.Cell className={css['credentials-info']}>
                <span>{getSecretAccessKey()}</span>
            </Table.Cell>
        </Table.Row>
    );
};

NewUserCredentialsRow.propTypes = {
    accessKey: PropTypes.string.isRequired,
    secretAccessKey: PropTypes.string.isRequired,
    index: PropTypes.number,
    showSecretKey: PropTypes.bool.isRequired,
    onClickShowSecretKey: PropTypes.func.isRequired
};

export default NewUserCredentialsRow;
